<div class="cosmos-sidebar__container">
  <div
    *ngFor="let item of _items"
    class="cosmos-sidebar__wrapper"
  >
    <a
      [routerLink]="item.link"
      class="cosmos-sidebar__item"
      routerLinkActive="cosmos-sidebar__item__active"
    >
      <mat-icon class="cosmos-sidebar__icon material-icons-outlined">
        <span>
          {{item.icon}}
        </span>
      </mat-icon>
      <span class="cosmos-sidebar__label">
        {{item.title}}
      </span>
    </a>
  </div>
</div>
